export default (state = { byTeamCode: {} }, action = {}) => {
  switch (action.type) {
    case 'FIFA_RANKING_SET':
      return action.payload;
    default:
      return state;
  }
};
